(function initVLibras() {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVLibras);
    return;
  }

  const btn = document.getElementById('btn-active-pounds');
  const container = document.getElementById('vlibras-container');

  if (!btn || !container) return;

  const toggleVLibras = () => {
    const isEnabled = container.classList.contains('enabled');
    container.classList.toggle('enabled', !isEnabled);
    container.classList.toggle('disabled', isEnabled);

    const accessToggle = document.getElementById('access-open');
    if (accessToggle) {
      accessToggle.checked = false;
    }

    const accessibilityWrapper = document.getElementById('access-info-wrapper');
    if (accessibilityWrapper) {
      const isVLibrasEnabled = container.classList.contains('enabled');
      const body = document.body;
      const isContrastActive = body.classList.contains('contrast-active');

      if (isVLibrasEnabled || isContrastActive) {
        accessibilityWrapper.classList.add('active');
      } else {
        accessibilityWrapper.classList.remove('active');
      }
    }

    try {
      const widget = window.VLibras?.Widget?.getInstance();
      widget?.[isEnabled ? 'hide' : 'show']();
    } catch {}
  };

  const init = () => btn.addEventListener('click', toggleVLibras);

  if (window.VLibras?.Widget) {
    init();
  } else {
    let attempts = 0;
    const check = setInterval(() => {
      if (window.VLibras?.Widget || ++attempts > 20) {
        clearInterval(check);
        init();
      }
    }, 100);
  }
})();
